import React from 'react';
import classnames from "classnames";
import "./HomeSection.scss";
const HomeSection = ({children, boxed}) => {
	return (
		<section className={classnames(
			"home-section",{
				"boxed": boxed
			}
		)}>
			{children}
		</section>
	);
};

export default HomeSection;